/** Public TBF MAP frontend URL (production default). */
export const DEFAULT_APP_URL = 'https://tbfmap.tanzaniabasketball.com';

const stripTrailingSlash = (url) => String(url || '').replace(/\/$/, '');

export const isLocalOrigin = (url) => {
  if (!url) return false;
  try {
    const hostname = new URL(url).hostname;
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0' ||
      hostname.endsWith('.local')
    );
  } catch {
    return /localhost|127\.0\.0\.1|0\.0\.0\.0/i.test(url);
  }
};

/**
 * Resolve the public app base URL for links in emails and auth redirects.
 * Prefers VITE_APP_URL; avoids localhost when a production URL is configured.
 */
export const getAppUrl = () => {
  const configured = import.meta.env.VITE_APP_URL?.trim();
  if (configured) return stripTrailingSlash(configured);

  if (typeof window !== 'undefined') {
    const origin = stripTrailingSlash(window.location.origin);
    if (!isLocalOrigin(origin)) return origin;
  }

  return DEFAULT_APP_URL;
};

export const getAppPath = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getAppUrl()}${normalizedPath}`;
};
